import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function DriversPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboarding.drivers.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-yellow"
          emoji="🎯"
          label={t("pages.onboarding.drivers.to_set_and_achieve_my_goals")}
          name={t("pages.onboarding.drivers.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.drivers.to_set_and_achieve_my_goals", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-purple"
          emoji="💪"
          label={t("pages.onboarding.drivers.to_boost_my_confidence")}
          name={t("pages.onboarding.drivers.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.drivers.to_boost_my_confidence", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="💫"
          label={t(
            "pages.onboarding.drivers.to_become_the_best_version_of_myself",
          )}
          name={t("pages.onboarding.drivers.heading", { lng: "en" })}
          onChange={handleChange}
          value={t(
            "pages.onboarding.drivers.to_become_the_best_version_of_myself",
            {
              lng: "en",
            },
          )}
        />

        <RadioInputButton
          className="from-pd-green"
          emoji="💚"
          label={t("pages.onboarding.drivers.to_improve_my_health")}
          name={t("pages.onboarding.drivers.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.drivers.to_improve_my_health", {
            lng: "en",
          })}
        />
      </Form>
    </Layout>
  )
}
